<div class="text-widget-navigation-n" [style.padding-bottom]="bottomGap">
  <div class="navigation-content" [style.max-width]="panelMaxWidth">
    <section
      *ngIf="hasIntroPanel"
      class="intro-panel"
      [style.background-color]="getIntroPanelBackgroundColor()"
      [style.border-color]="getIntroPanelBorderColor()"
      [style.border-radius]="getIntroPanelBorderRadius()"
      [style.border-width]="getIntroPanelBorderWidth()"
      [style.box-shadow]="getIntroPanelBoxShadow()"
      [style.padding]="getIntroPanelPadding()"
      [style.margin-bottom]="getIntroPanelMarginBottom()"
      [style.--nav-intro-gap]="getIntroPanelGap()"
      [style.--nav-intro-icon-wrap-size]="getIntroIconWrapSize()"
      [style.--nav-intro-icon-size]="getIntroIconSize()"
      [style.--nav-intro-icon-radius]="getIntroIconBorderRadius()"
      [style.--nav-intro-icon-bg-color]="getIntroIconBackgroundColor()"
      [style.--nav-intro-icon-color]="getIntroIconColor()"
      [style.--nav-intro-icon-shadow]="getIntroIconBoxShadow()"
    >
      <span class="intro-icon-wrap" *ngIf="getIntroIcon() || getIntroIconText()">
        <img *ngIf="isImageIcon(getIntroIcon()); else introMatOrTextIcon" class="intro-icon-image" [src]="getIntroIcon()" alt="" />
        <ng-template #introMatOrTextIcon>
          <mat-icon *ngIf="getIntroIcon(); else introTextIcon" class="intro-icon">{{ getIntroIcon() }}</mat-icon>
          <ng-template #introTextIcon>
            <span class="intro-icon-text">{{ getIntroIconText() }}</span>
          </ng-template>
        </ng-template>
      </span>

      <span class="intro-copy">
        <span
          *ngIf="getIntroTitle()"
          class="intro-title"
          [style.color]="getIntroTitleColor()"
          [style.font-size]="getIntroTitleFontSize()"
          [style.font-family]="getIntroTitleFontFamily()"
          [style.font-weight]="getIntroTitleFontWeight()"
        >
          {{ getIntroTitle() }}
        </span>
        <span
          *ngIf="getIntroText()"
          class="intro-text"
          [style.color]="getIntroSubtitleColor()"
          [style.font-size]="getIntroSubtitleFontSize()"
          [style.font-family]="getIntroSubtitleFontFamily()"
          [style.font-weight]="getIntroSubtitleFontWeight()"
        >
          {{ getIntroText() }}
        </span>
      </span>
    </section>

    <div
      *ngIf="hasSectionLabel"
      class="section-label"
      [style.color]="getSectionLabelColor()"
      [style.font-size]="getSectionLabelFontSize()"
      [style.font-family]="getSectionLabelFontFamily()"
      [style.font-weight]="getSectionLabelFontWeight()"
      [style.letter-spacing]="getSectionLabelLetterSpacing()"
      [style.margin-bottom]="getSectionLabelMarginBottom()"
    >
      {{ sectionLabelText }}
    </div>

  <div
    *ngIf="hasOptions"
    class="options-panel"
    [style.grid-template-columns]="buttonsGridTemplateColumns"
    [style.gap]="optionsGap"
  >
    <section
      *ngFor="let option of navigationOptions; trackBy: trackByIndex"
      class="option-card"
      [class.option-card-open]="optionHasExpandedDropdown(option)"
      [style.background-color]="getOptionBackgroundColor(option)"
      [style.color]="getOptionTextColor(option)"
      [style.border-color]="getOptionBorderColor(option)"
      [style.border-width]="getOptionBorderWidth(option)"
      [style.border-radius]="getOptionBorderRadius(option)"
      [style.box-shadow]="getOptionBoxShadow(option)"
      [style.padding]="getOptionPadding(option)"
      [style.height]="getRenderedOptionHeight(option)"
      [style.min-height]="getOptionMinHeight(option)"
      [style.min-width]="getOptionMinWidth(option)"
      [style.width]="getOptionWidth(option)"
      [style.justify-self]="moduleJustify"
      [style.--nav-accent-color]="getTopBorderColor(option)"
      [style.--nav-divider-color]="getDividerColor(option)"
      [style.--nav-icon-bg-color]="getIconBackgroundColor(option)"
      [style.--nav-icon-color]="getIconColor(option)"
      [style.--nav-module-color]="getModuleLabelColor(option)"
      [style.--nav-title-color]="getTitleColor(option)"
      [style.--nav-subtitle-color]="getSubtitleColor(option)"
      [style.font-size]="getOptionFontSize(option)"
      [style.font-weight]="getOptionFontWeight(option)"
      [style.font-style]="getOptionFontStyle(option)"
      [style.font-family]="getOptionFontFamily(option)"
    >
      <span
        *ngIf="hasActionButtons(option); else legacyOptionCard"
        class="card-shell"
        [style.padding]="cardPadding"
        [style.--nav-top-border-height]="topBorderHeight"
        [style.--nav-header-gap]="headerGap"
        [style.--nav-icon-wrap-size]="getIconWrapSize()"
        [style.--nav-icon-size]="getIconSize()"
        [style.--nav-icon-radius]="getIconBorderRadius()"
        [style.--nav-module-font-size]="getModuleLabelFontSize()"
        [style.--nav-module-font-weight]="getModuleLabelFontWeight()"
        [style.--nav-title-font-size]="getTitleFontSize()"
        [style.--nav-title-font-weight]="getTitleFontWeight()"
        [style.--nav-subtitle-font-size]="getSubtitleFontSize()"
        [style.--nav-subtitle-font-weight]="getSubtitleFontWeight()"
      >
        <span class="card-header">
          <span class="card-top-icon-wrap" *ngIf="getOptionTopIcon(option)">
            <img *ngIf="isImageIcon(getOptionTopIcon(option)); else optionTopMatIcon" class="card-top-icon-image" [src]="getOptionTopIcon(option)" alt="" />
            <ng-template #optionTopMatIcon>
              <mat-icon class="card-top-icon">{{ getOptionTopIcon(option) }}</mat-icon>
            </ng-template>
          </span>

          <span class="card-heading">
            <span *ngIf="getOptionModuleLabel(option)" class="card-module-label">
              {{ getOptionModuleLabel(option) }}
            </span>

            <span class="card-title">
              {{ formatOptionLabel(option) }}
            </span>

            <span *ngIf="getOptionSubtitle(option)" class="card-subtitle">
              {{ getOptionSubtitle(option) }}
            </span>
          </span>
        </span>

        <span class="card-divider"></span>

        <span class="action-buttons" [style.gap]="actionButtonsGap">
          <span
            class="action-button-group"
            *ngFor="let button of getActionButtons(option); trackBy: trackByIndex"
            [class.action-button-group-open]="isDropdownExpanded(option, button)"
          >
            <button
              type="button"
              class="option-btn"
              [class.expanded]="isDropdownExpanded(option, button)"
              [disabled]="option.disabled || button.disabled"
              [style.background-color]="getActionButtonBackgroundColor(button)"
              [style.color]="getActionButtonTextColor(button)"
              [style.border-radius]="getActionButtonBorderRadius(button)"
              [style.min-height]="getActionButtonMinHeight(button)"
              [style.font-size]="getActionButtonFontSize(button)"
              [style.font-weight]="getActionButtonFontWeight(button)"
              [style.padding]="getActionButtonPadding(button)"
              (click)="onOptionClick(option, button, $event)"
            >
              {{ formatButtonLabel(button) }}
            </button>

            <span class="dropdown-buttons" *ngIf="hasDropdownItems(button) && isDropdownExpanded(option, button)">
              <button
                *ngFor="let item of getDropdownItems(button); trackBy: trackByIndex"
                type="button"
                class="dropdown-btn"
                [disabled]="option.disabled || item.disabled"
                [style.background-color]="getDropdownButtonBackgroundColor(item)"
                [style.color]="getDropdownButtonTextColor(item)"
                [style.border-radius]="getDropdownButtonBorderRadius(item)"
                [style.min-height]="getDropdownButtonMinHeight(item)"
                [style.font-size]="getDropdownButtonFontSize(item)"
                [style.font-weight]="getDropdownButtonFontWeight(item)"
                [style.padding]="getDropdownButtonPadding(item)"
                (click)="onDropdownItemClick(option, item, $event)"
              >
                {{ formatButtonLabel(item) }}
              </button>
            </span>
          </span>
        </span>
      </span>
      <ng-template #legacyOptionCard>
        <button
          type="button"
          class="legacy-option-btn"
          [disabled]="option.disabled"
          (click)="onLegacyOptionClick(option, $event)"
        >
          <span class="legacy-card-shell">
            <span class="legacy-card-top-row">
              <span class="legacy-card-top-left">
                <span class="legacy-card-top-icon-wrap" *ngIf="getOptionTopIcon(option)">
                  <img *ngIf="isImageIcon(getOptionTopIcon(option)); else legacyTopMatIcon" class="legacy-card-top-icon-image" [src]="getOptionTopIcon(option)" alt="" />
                  <ng-template #legacyTopMatIcon>
                    <mat-icon class="legacy-card-top-icon">{{ getOptionTopIcon(option) }}</mat-icon>
                  </ng-template>
                </span>

                <span *ngIf="getOptionModuleLabel(option)" class="legacy-card-module-label">
                  {{ getOptionModuleLabel(option) }}
                </span>
              </span>
            </span>

            <span class="legacy-card-title">
              {{ formatOptionLabel(option) }}
            </span>

            <span *ngIf="getOptionSubtitle(option)" class="legacy-card-subtitle">
              {{ getOptionSubtitle(option) }}
            </span>

            <span class="legacy-card-divider"></span>

            <span class="legacy-card-bottom-icon-wrap" *ngIf="getOptionBottomIcon(option)">
              <img *ngIf="isImageIcon(getOptionBottomIcon(option)); else legacyBottomMatIcon" class="legacy-card-bottom-icon-image" [src]="getOptionBottomIcon(option)" alt="" />
              <ng-template #legacyBottomMatIcon>
                <mat-icon class="legacy-card-bottom-icon">{{ getOptionBottomIcon(option) }}</mat-icon>
              </ng-template>
            </span>
          </span>
        </button>
      </ng-template>
    </section>
  </div>
  </div>
</div>
